import React from 'react';
import styled from 'styled-components';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { Colors, Float } from '../../../ui';
import { Position } from '../../../ui/Position';
import { useResolve } from '../../Container';
import { copy } from '../commands/ClipboardCommands';
import { useEditorSessionObserver } from '../EditorSession';
import { Selection } from '../Selection';

const ActionButton = styled.div`
    display: flex;
    gap: .25rem;
    align-items: center;
    justify-content: center;
    color: ${Colors.text};
    cursor: pointer;
    padding: 0.25rem;
    
    &:hover {
        background: ${Colors.hover};
    }
    &:active {
        background: ${Colors.active};
    }

`;

export const ReplayCopyView = () => {

    const dispatch = useResolve(CommandDispatcher);
    const selection = useEditorSessionObserver(Selection);

    if (!selection.size) return null;

    return <Position at="top" inset="1">
        <Float inline>
            <ActionButton onClick={() => dispatch(copy)}>
                <Icon size="1.5" src="deqo://icons/hero/clipboard" />
                Copy Selection
            </ActionButton>
        </Float>
    </Position>;
};
